import React from 'react';
import { AccountVerificationProvider } from '../context/EWContext';
import EWStepper from '../components/EWStepper/EWStepper';

export default function Rescheduling(props) {
  const { eligibilityConfig } = props;

  return (
    <React.Fragment>
      <AccountVerificationProvider config={eligibilityConfig}>
        <EWStepper></EWStepper>
      </AccountVerificationProvider>
    </React.Fragment>
  );
};
